import { twoItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { getWindCardinalDirection } from 'App/Map/PanelDetails/StackemCharts/_utils/by-domain/wind/getWindCardinalDirection'
import { translate } from 'i18n/i18n'

export const windDirection: typeof valueTypeRenderers.windDirection = {
  label: () => translate.phrases.banyanApp('Wind Direction'),
  point: () => {
    const baseLabel = translate.phrases.banyanApp('Wind Direction')

    const labelCardinalDirection = twoItemLabel([
      baseLabel,
      translate.phrases.banyanApp('Cardinal Direction'),
    ])

    const labelDegrees = twoItemLabel([baseLabel, '°'])

    return (value) => {
      if (value !== null && typeof value === 'object' && 'average' in value) {
        return [
          {
            id: 'cardinalDirection',
            value: getWindCardinalDirection(value.average),
            label: labelCardinalDirection,
          },
          {
            id: 'degrees',
            value: value.average === null ? translate.phrases.templates('-') : value.average.toFixed(0),
            label: labelDegrees,
          },
        ]
      } else {
        return [
          {
            id: 'cardinalDirection',
            value: getWindCardinalDirection(value),
            label: labelCardinalDirection,
          },
          {
            id: 'degrees',
            value: value === null ? translate.phrases.templates('-') : value.toFixed(0),
            label: labelDegrees,
          },
        ]
      }
    }
  },
}
